<template>
  <div class="container">
    <van-nav-bar
      title="我的电子票据"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    >
      <template #title>
        <CanlendarSearch
          @update="getParams"
          :initDate="initDate"
        ></CanlendarSearch>
      </template>
    </van-nav-bar>
    <div class="mt-header-nav">
      <div class="bill-title">挂号电子票据</div>
      <van-list v-if="data.cardBookingList && data.cardBookingList.length">
        <van-cell
          v-for="(item, index) in data.cardBookingList"
          :key="index"
          @click="onView(item)"
        >
          <ListItem :info="item"></ListItem>
        </van-cell>
      </van-list>
      <div class="empty" v-else>
        暂无票据!
      </div>

      <div class="bill-title">门诊电子票据</div>
      <van-list v-if="data.outPatientList && data.outPatientList.length">
        <van-cell
          v-for="(item, index) in data.outPatientList"
          :key="index"
          @click="onView(item)"
        >
          <ListItem :info="item"></ListItem>
        </van-cell>
      </van-list>
      <div class="empty" v-else>
        暂无票据!
      </div>
      <div class="bill-title">住院电子票据</div>
      <van-list v-if="data.inHospitalList && data.inHospitalList.length">
        <van-cell
          v-for="(item, index) in data.inHospitalList"
          :key="index"
          @click="onView(item)"
        >
          <ListItem :info="item"></ListItem>
        </van-cell>
      </van-list>
      <div class="empty" v-else>
        暂无票据!
      </div>
    </div>
  </div>
</template>

<script>
import CanlendarSearch from "@/components/CanlendarSearch";
import { NavBar, List, Cell } from "vant";
import { cache } from "@/utils/common";
import moment from "moment";
import ListItem from "./ListItem";
export default {
  components: {
    CanlendarSearch,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Cell.name]: Cell,
    ListItem,
  },
  data() {
    return {
      data: {},
      initDate: [moment(), moment()],
      contact: {},
      startDate: "",
      endDate: "",
    };
  },
  created() {
    this.contact = cache.get("currentContact");
    this.startDate = this.initDate[0].format("YYYY-MM-DD");
    this.endDate = this.initDate[1].format("YYYY-MM-DD");

    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$post("MyElectricBillPage", {
        diagnosisCardNo: this.contact.diagnosisCardNo,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then(res => {
        this.data = res.data;
      });
    },
    getParams(date) {
      this.startDate = date.startDate;
      this.endDate = date.endDate;
      this.fetchData();
    },
    onClickLeft() {
      this.$router.push({
        name: "user",
      });
    },
    onView(item) {
      if (item.pictureNetUrl) {
        location.href = item.pictureNetUrl;
      } else {
        this.$post("MyElectricBillGetDetail", {
          billBatchCode: item.billBatchCode,
          billNo: item.billNo,
          random: item.random,
          // patientId: "string",
          // ticketNo: "string",
        }).then(res => {
          if (res.data.pictureNetUrl) {
            location.href = res.data.pictureNetUrl;
          } else {
            this.$toast.error("未查询到电子票据明细信息。");
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bill-title {
  font-size: 15px;
  padding: 5px;
  background: #fffbea;
  border-left: 3px solid #1989fa;
}
/deep/.van-list {
  padding: 8px;
  .van-cell {
    box-shadow: 1px 1px 4px #d8d8d8;
    margin-bottom: 8px;
    border-radius: 3px;
  }
}
.empty {
  padding: 30px;
  color: #999;
  text-align: center;
  font-size: 14px;
}
</style>
